import { JsonDecoder } from 'ts.data.json';
import { OrderApprovalForm } from './model';

export const orderApprovalFormDecoder = JsonDecoder.object<OrderApprovalForm>(
    {
        id: JsonDecoder.string
    },
    'OrderApprovalForm'
);

export const orderApprovalFormsResponse = JsonDecoder.array<OrderApprovalForm>(
    orderApprovalFormDecoder,
    'OrderApprovalForm[]'
);
